import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";

import { urlPacote } from "services/bidFreteApi";
import { fmtDataHora } from "../regras";

// Aba Pacote (H6 PO1-2845, só RFP): download das duas planilhas por URL
// assinada (GET /pacote/:arquivo devolve { url }; abre em nova aba) e a data
// de geração. Sem URL fixa: o link expira.

const ARQUIVOS = [
  { chave: "embarques", titulo: "Planilha de embarques", descricao: "Uma linha por embarque (CTe, romaneio ou NF), anonimizada: dia, origem e destino com CEP completo, perfil da carga. Sem destinatário, documento, frete cobrado nem transportadora atual." },
  { chave: "modelo", titulo: "Planilha modelo", descricao: "Abas TB_FrTbCusto e TB_FrTbTaxa já com as UFs e cidades de destino do escopo. A transportadora responde só nela." },
];

export default function AbaPacote({ bid, empresaId }) {
  const [abrindo, setAbrindo] = useState(null);
  const [erro, setErro] = useState(null);
  const pronto = Boolean(bid && bid.pacoteEm);

  const abrir = async (arquivo) => {
    if (abrindo) return;
    setAbrindo(arquivo);
    setErro(null);
    try {
      const r = await urlPacote(empresaId, bid.id, arquivo);
      if (r && r.url) window.open(r.url, "_blank", "noopener");
      else setErro("A URL do arquivo não veio.");
    } catch (err) {
      const data = (err.response && err.response.data) || {};
      setErro(data.error || "Não foi possível obter o arquivo.");
    } finally {
      setAbrindo(null);
    }
  };

  if (!pronto) return <div className="bf-placeholder">O pacote ainda não foi gerado. Com a baseline concluída, use o botão Gerar pacote.</div>;

  return (
    <>
      <div className="lf-muted" style={{ marginBottom: 10 }}>
        Gerado em {fmtDataHora(bid.pacoteEm)}. O link de download expira em alguns minutos; gere outro quando precisar.
      </div>
      {erro ? <div className="lf-aviso lf-aviso-danger">{erro}</div> : null}
      <div className="bf-pacote-arquivos">
        {ARQUIVOS.map((a) => (
          <div key={a.chave} className="bf-pacote-arquivo">
            <div className="lf-kv-value">{a.titulo}</div>
            <div className="lf-muted">{a.descricao}</div>
            <div>
              <Button color="info" size="sm" outline onClick={() => abrir(a.chave)} disabled={Boolean(abrindo)}>
                {abrindo === a.chave ? <Spinner size="sm" /> : "Baixar"}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
